
const Successmsg = (props) => (
  <div className="alert alert-success">
     {props.message}
  </div>
)

export default Successmsg